
// `Poll` re-exports bt-common's canonical PollSchema-derived type so
// downstream importers (create-poll, scheduled-message-editor-wrapper,
// reducers) don't drift. NO local redefinition — see #36.
export type { Poll } from "@bt-common/schemas/bt/user-message";

// `ExtendedUserMessage` lives in common/models/extend-user-message.ts
// — that's the canonical extension type. The local re-declaration was
// a dupe (#39).
export { type ExtendedUserMessage } from "@common/models/extend-user-message";

// WAWeb-style id/contact shapes used by the contact picker UI. NOT the
// same as bt-common's WaWid (which has `server`+`user`+`_serialized`)
// — these are display-layer wrappers around the picker model.
export interface WhatsAppId {
  _serialized: string;
  id?: string;
}

export interface WhatsAppContact {
  id: WhatsAppId;
  name?: string;
  displayName?: string;
  pushname?: string;
  imgUrl?: string;
}

export type AddScheduledMessageButtonProps = {
  isDisabled?: boolean;
  classes?: Record<string, string>;
};

/** UI display shape for the contact picker. NOT a `userMessages`
 *  doc-side MessageContact (which lives in bt-common with different
 *  field names — `imageUrl` vs `imgUrl`, etc.). Renamed from the
 *  ambiguous `MessageContact` to make the distinct concept obvious. */
export interface ContactPickItem {
  id: string;
  name?: string;
  displayName?: string;
  mobile?: string;
  imgUrl?: string;
}

export const initialPoll = {
    question: '',
    options: [
      { id: Math.floor(Math.random() * 1000000000000000000000000), text: '', order: 0 },
      { id: Math.floor(Math.random() * 1000000000000000000000000), text: '', order: 1 },
    ],
    allowMultiple: false,
  }
  